import { sharedOptionCss } from "../ActionsDropdown.style";

export const anchorCss = {
  ...sharedOptionCss,
  height: "auto",
};
